export const REGENCY_CITY = [
  { name: "KAB. BEKASI", code: "0102" },
  { name: "KAB. PURWAKARTA", code: "0103" },
  { name: "KAB. KARAWANG", code: "0106" },
  { name: "KAB. BOGOR", code: "0108" },
  { name: "KAB. SUKABUMI", code: "0109" },
  { name: "KAB. CIANJUR", code: "0110" },
  { name: "KAB. BANDUNG", code: "0111" },
  { name: "KAB. SUMEDANG", code: "0112" },
  { name: "KAB. TASIKMALAYA", code: "0113" },
  { name: "KAB. GARUT", code: "0114" },
  { name: "KAB. CIAMIS", code: "0115" },
  { name: "KAB. CIREBON", code: "0116" },
  { name: "KAB. KUNINGAN", code: "0117" },
  { name: "KAB. INDRAMAYU", code: "0118" },
  { name: "KAB. MAJALENGKA", code: "0119" },
  { name: "KAB. SUBANG", code: "0121" },
  { name: "KAB. BANDUNG BARAT", code: "0122" },
  { name: "KAB. PANGANDARAN", code: "0123" },
  { name: "KOTA BANJAR", code: "0180" },
  { name: "KOTA BANDUNG", code: "0191" },
  { name: "KOTA BOGOR", code: "0192" },
  { name: "KOTA SUKABUMI", code: "0193" },
  { name: "KOTA CIREBON", code: "0194" },
  { name: "KOTA TASIKMALAYA", code: "0195" },
  { name: "KOTA CIMAHI", code: "0196" },
  { name: "KOTA DEPOK", code: "0197" },
  { name: "KOTA BEKASI", code: "0198" },
  { name: "KAB. LEBAK", code: "0201" },
  { name: "KAB. PANDEGLANG", code: "0202" },
  { name: "KAB. SERANG", code: "0203" },
  { name: "KAB. TANGERANG", code: "0204" },
  { name: "KOTA CILEGON", code: "0291" },
  { name: "KOTA TANGERANG", code: "0292" },
  { name: "KOTA SERANG", code: "0293" },
  { name: "KOTA TANGERANG SELATAN", code: "0294" },
  { name: "DKI JAYA", code: "0300" },
  { name: "WIL. KOTA JAKARTA PUSAT", code: "0391" },
  { name: "WIL. KOTA JAKARTA UTARA", code: "0392" },
  { name: "WIL. KOTA JAKARTA BARAT", code: "0393" },
  { name: "WIL. KOTA JAKARTA SELATAN", code: "0394" },
  { name: "WIL. KOTA JAKARTA TIMUR", code: "0395" },
  { name: "WIL. KEPULAUAN SERIBU", code: "0396" },
  { name: "D.I YOGYAKARTA", code: "0500" },
  { name: "KAB. BANTUL", code: "0501" },
  { name: "KAB. SLEMAN", code: "0502" },
  { name: "KAB. GUNUNG KIDUL", code: "0503" },
  { name: "KAB. KULON PROGO", code: "0504" },
  { name: "KOTA YOGYAKARTA", code: "0591" },
  { name: "PROV. JAWA TENGAH", code: "0900" },
  { name: "KAB. SEMARANG", code: "0901" },
  { name: "KAB. KENDAL", code: "0902" },
  { name: "KAB. DEMAK", code: "0903" },
  { name: "KAB. GROBOGAN", code: "0904" },
  { name: "KAB. PEKALONGAN", code: "0905" },
  { name: "KAB. TEGAL", code: "0906" },
  { name: "KAB. BREBES", code: "0907" },
  { name: "KAB. PATI", code: "0908" },
  { name: "KAB. KUDUS", code: "0909" },
  { name: "KAB. PEMALANG", code: "0910" },
  { name: "KAB. JEPARA", code: "0911" },
  { name: "KAB. REMBANG", code: "0912" },
  { name: "KAB. BLORA", code: "0913" },
  { name: "KAB. BANYUMAS", code: "0914" },
  { name: "KAB. CILACAP", code: "0915" },
  { name: "KAB. PURBALINGGA", code: "0916" },
  { name: "KAB. BANJARNEGARA", code: "0917" },
  { name: "KAB. MAGELANG", code: "0918" },
  { name: "KAB. TEMANGGUNG", code: "0919" },
  { name: "KAB. WONOSOBO", code: "0920" },
  { name: "KAB. PURWOREJO", code: "0921" },
  { name: "KAB. KEBUMEN", code: "0922" },
  { name: "KAB. KLATEN", code: "0923" },
  { name: "KAB. BOYOLALI", code: "0924" },
  { name: "KAB. SRAGEN", code: "0925" },
  { name: "KAB. SUKOHARJO", code: "0926" },
  { name: "KAB. KARANGANYAR", code: "0927" },
  { name: "KAB. WONOGIRI", code: "0928" },
  { name: "KAB. BATANG", code: "0929" },
  { name: "KOTA SEMARANG", code: "0991" },
  { name: "KOTA SALATIGA", code: "0992" },
  { name: "KOTA PEKALONGAN", code: "0993" },
  { name: "KOTA TEGAL", code: "0994" },
  { name: "KOTA MAGELANG", code: "0995" },
  { name: "KOTA SURAKARTA/SOLO", code: "0996" },
  { name: "PROV. JAWA TIMUR", code: "1200" },
  { name: "KAB. GRESIK", code: "1201" },
  { name: "KAB. SIDOARJO", code: "1202" },
  { name: "KAB. MOJOKERTO", code: "1203" },
  { name: "KAB. JOMBANG", code: "1204" },
  { name: "KAB. SAMPANG", code: "1205" },
  { name: "KAB. PAMEKASAN", code: "1206" },
  { name: "KAB. SUMENEP", code: "1207" },
  { name: "KAB. BANGKALAN", code: "1208" },
  { name: "KAB. BONDOWOSO", code: "1209" },
  { name: "KAB. BANYUWANGI", code: "1211" },
  { name: "KAB. JEMBER", code: "1212" },
  { name: "KAB. MALANG", code: "1213" },
  { name: "KAB. PASURUAN", code: "1214" },
  { name: "KAB. PROBOLINGGO", code: "1215" },
  { name: "KAB. LUMAJANG", code: "1216" },
  { name: "KAB. KEDIRI", code: "1217" },
  { name: "KAB. NGANJUK", code: "1218" },
  { name: "KAB. TULUNGAGUNG", code: "1219" },
  { name: "KAB. TRENGGALEK", code: "1220" },
  { name: "KAB. BLITAR", code: "1221" },
  { name: "KAB. MADIUN", code: "1222" },
  { name: "KAB. NGAWI", code: "1223" },
  { name: "KAB. MAGETAN", code: "1224" },
  { name: "KAB. PONOROGO", code: "1225" },
  { name: "KAB. PACITAN", code: "1226" },
  { name: "KAB. BOJONEGORO", code: "1227" },
  { name: "KAB. TUBAN", code: "1228" },
  { name: "KAB. LAMONGAN", code: "1229" },
  { name: "KAB. SITUBONDO", code: "1230" },
  { name: "KOTA BATU", code: "1271" },
  { name: "KOTA SURABAYA", code: "1291" },
  { name: "KOTA MOJOKERTO", code: "1292" },
  { name: "KOTA MALANG", code: "1293" },
  { name: "KOTA PASURUAN", code: "1294" },
  { name: "KOTA PROBOLINGGO", code: "1295" },
  { name: "KOTA BLITAR", code: "1296" },
  { name: "KOTA KEDIRI", code: "1297" },
  { name: "KOTA MADIUN", code: "1298" },
  { name: "KAB. BENGKULU SELATAN", code: "2301" },
  { name: "KAB. BENGKULU UTARA", code: "2302" },
  { name: "KAB. REJANG LEBONG", code: "2303" },
  { name: "KAB. LEBONG", code: "2304" },
  { name: "KAB. KEPAHIANG", code: "2305" },
  { name: "KAB. MUKOMUKO", code: "2306" },
  { name: "KAB. SELUMA", code: "2307" },
  { name: "KAB. KAUR", code: "2308" },
  { name: "KAB. BENGKULU TENGAH", code: "2309" },
  { name: "KOTA BENGKULU", code: "2391" },
  { name: "KAB. BATANGHARI", code: "3101" },
  { name: "KAB. SAROLANGUN", code: "3104" },
  { name: "KAB. KERINCI", code: "3105" },
  { name: "KAB. MUARO JAMBI", code: "3106" },
  { name: "KAB. TANJUNG JABUNG BARAT", code: "3107" },
  { name: "KAB. TANJUNG JABUNG TIMUR", code: "3108" },
  { name: "KAB. TEBO", code: "3109" },
  { name: "KAB. MERANGIN", code: "3111" },
  { name: "KAB. BUNGO", code: "3112" },
  { name: "KOTA JAMBI", code: "3191" },
  { name: "KOTA SUNGAI PENUH", code: "3192" },
  { name: "KAB. ACEH BESAR", code: "3201" },
  { name: "KAB. PIDIE", code: "3202" },
  { name: "KAB. ACEH UTARA", code: "3203" },
  { name: "KAB. ACEH TIMUR", code: "3204" },
  { name: "KAB. ACEH SELATAN", code: "3205" },
  { name: "KAB. ACEH BARAT", code: "3206" },
  { name: "KAB. ACEH TENGAH", code: "3207" },
  { name: "KAB. ACEH TENGGARA", code: "3208" },
  { name: "KAB. ACEH SINGKIL", code: "3209" },
  { name: "KAB. ACEH JEUMPA/BIREUEN", code: "3210" },
  { name: "KAB. ACEH TAMIANG", code: "3211" },
  { name: "KAB. GAYO LUWES", code: "3212" },
  { name: "KAB. ACEH BARAT DAYA", code: "3213" },
  { name: "KAB. ACEH JAYA", code: "3214" },
  { name: "KAB. NAGAN RAYA", code: "3215" },
  { name: "KAB. ACEH SIMEULEU", code: "3216" },
  { name: "KAB. BENER MERIAH", code: "3217" },
  { name: "KAB. PIDIE JAYA", code: "3218" },
  { name: "KAB. SUBULUSSALAM", code: "3219" },
  { name: "KOTA BANDA ACEH", code: "3291" },
  { name: "KOTA SABANG", code: "3292" },
  { name: "KOTA LHOKSEUMAWE", code: "3293" },
  { name: "KOTA LANGSA", code: "3294" },
  { name: "KAB. DELI SERDANG", code: "3301" },
  { name: "KAB. LANGKAT", code: "3302" },
  { name: "KAB. KARO", code: "3303" },
  { name: "KAB. SIMALUNGUN", code: "3304" },
  { name: "KAB. LABUHAN BATU", code: "3305" },
  { name: "KAB. ASAHAN", code: "3306" },
  { name: "KAB. DAIRI", code: "3307" },
  { name: "KAB. TAPANULI UTARA", code: "3308" },
  { name: "KAB. TAPANULI TENGAH", code: "3309" },
  { name: "KAB. TAPANULI SELATAN", code: "3310" },
  { name: "KAB. NIAS", code: "3311" },
  { name: "KAB. TOBA SAMOSIR", code: "3313" },
  { name: "KAB. MANDAILING NATAL", code: "3314" },
  { name: "KAB. NIAS SELATAN", code: "3315" },
  { name: "KAB. HUMBANG HASUNDUTAN", code: "3316" },
  { name: "KAB. PAKPAK BHARAT", code: "3317" },
  { name: "KAB. SAMOSIR", code: "3318" },
  { name: "KAB. SERDANG BEDAGAI", code: "3319" },
  { name: "KAB. BATU BARA", code: "3321" },
  { name: "KAB. PADANG LAWAS", code: "3322" },
  { name: "KAB. PADANG LAWAS UTARA", code: "3323" },
  { name: "KAB. LABUHANBATU SELATAN", code: "3324" },
  { name: "KAB. LABUHANBATU UTARA", code: "3325" },
  { name: "KAB. NIAS BARAT", code: "3326" },
  { name: "KAB. NIAS UTARA", code: "3327" },
  { name: "KOTA TEBING TINGGI", code: "3391" },
  { name: "KOTA BINJAI", code: "3392" },
  { name: "KOTA PEMATANG SIANTAR", code: "3393" },
  { name: "KOTA TANJUNG BALAI", code: "3394" },
  { name: "KOTA SIBOLGA", code: "3395" },
  { name: "KOTA MEDAN", code: "3396" },
  { name: "KOTA GUNUNG SITOLI", code: "3397" },
  { name: "KOTA PADANG SIDEMPUAN", code: "3399" },
  { name: "KAB. AGAM", code: "3401" },
  { name: "KAB. PASAMAN", code: "3402" },
  { name: "KAB. LIMAPULUH KOTO", code: "3403" },
  { name: "KAB. SOLOK SELATAN", code: "3404" },
  { name: "KAB. PADANG PARIAMAN", code: "3405" },
  { name: "KAB. PESISIR SELATAN", code: "3406" },
  { name: "KAB. TANAH DATAR", code: "3407" },
  { name: "KAB. SAWAHLUNTO/SIJUNJUNG", code: "3408" },
  { name: "KAB. KEPULAUAN MENTAWAI", code: "3409" },
  { name: "KAB. PASAMAN BARAT", code: "3410" },
  { name: "KAB. DHARMASRAYA", code: "3411" },
  { name: "KAB. SOLOK", code: "3412" },
  { name: "KOTA BUKITTINGGI", code: "3491" },
  { name: "KOTA PADANG", code: "3492" },
  { name: "KOTA SAWAHLUNTO", code: "3493" },
  { name: "KOTA PADANG PANJANG", code: "3494" },
  { name: "KOTA SOLOK", code: "3495" },
  { name: "KOTA PAYAKUMBUH", code: "3496" },
  { name: "KOTA PARIAMAN", code: "3497" },
  { name: "KAB. KAMPAR", code: "3501" },
  { name: "KAB. BENGKALIS", code: "3502" },
  { name: "KAB. INDRAGIRI HULU", code: "3504" },
  { name: "KAB. INDRAGIRI HILIR", code: "3505" },
  { name: "KAB. ROKAN HULU", code: "3508" },
  { name: "KAB. ROKAN HILIR", code: "3509" },
  { name: "KAB. PELALAWAN", code: "3510" },
  { name: "KAB. SIAK", code: "3511" },
  { name: "KAB. KUANTAN SINGINGI", code: "3512" },
  { name: "KAB. KEPULAUAN MERANTI", code: "3513" },
  { name: "KOTA PEKANBARU", code: "3591" },
  { name: "KOTA DUMAI", code: "3592" },
  { name: "KAB. MUSI BANYUASIN", code: "3606" },
  { name: "KAB. OGAN KOMERING ULU", code: "3607" },
  { name: "KAB. LEMATANG ILIR OGAN TENGAH (MUARA ENIM)", code: "3608" },
  { name: "KAB. LAHAT", code: "3609" },
  { name: "KAB. MUSI RAWAS", code: "3610" },
  { name: "KAB. OGAN KOMERING ILIR", code: "3611" },
  { name: "KAB. BANYUASIN", code: "3613" },
  { name: "KAB. OGAN KOMEING ULU SELATAN", code: "3614" },
  { name: "KAB. OGAN KOMEING ULU TIMUR", code: "3615" },
  { name: "KAB. OGAN ILIR", code: "3616" },
  { name: "KAB. EMPAT LAWANG", code: "3617" },
  { name: "KAB. MUSI RAWAS UTARA", code: "3618" },
  { name: "KAB. PENUKAL ABAB LEMATANG ILIR", code: "3619" },
  { name: "KOTA PALEMBANG", code: "3691" },
  { name: "KOTA LUBUKLINGGAU", code: "3693" },
  { name: "KOTA PRABUMULIH", code: "3694" },
  { name: "KOTA PAGAR ALAM", code: "3697" },
  { name: "KAB. BANGKA", code: "3701" },
  { name: "KAB. BELITUNG", code: "3702" },
  { name: "KAB. BANGKA BARAT", code: "3703" },
  { name: "KAB. BANGKA SELATAN", code: "3704" },
  { name: "KAB. BANGKA TENGAH", code: "3705" },
  { name: "KAB. BELITUNG TIMUR", code: "3706" },
  { name: "KAB. BANGKA BELITUNG(LBU 2016)/KOTA PANGKAL PINANG", code: "3707" },
  { name: "KOTA PANGKAL PINANG", code: "3791" },
  { name: "KAB. KARIMUN", code: "3801" },
  { name: "KAB. LINGGA", code: "3802" },
  { name: "KAB. NATUNA", code: "3803" },
  { name: "KAB. BINTAN", code: "3804" },
  { name: "KAB. ANAMBAS", code: "3805" },
  { name: "KOTA TANJUNG PINANG", code: "3891" },
  { name: "KOTA BATAM", code: "3892" },
  { name: "KAB. LAMPUNG SELATAN", code: "3901" },
  { name: "KAB. LAMPUNG TENGAH", code: "3902" },
  { name: "KAB. LAMPUNG UTARA", code: "3903" },
  { name: "KAB. LAMPUNG BARAT", code: "3904" },
  { name: "KAB. TULANG BAWANG", code: "3905" },
  { name: "KAB. TANGGAMUS", code: "3906" },
  { name: "KAB. LAMPUNG TIMUR", code: "3907" },
  { name: "KAB. WAY KANAN", code: "3908" },
  { name: "KAB. PESAWARAN", code: "3909" },
  { name: "KAB. PRINGSEWU", code: "3910" },
  { name: "KAB. TULANG BAWANG BARAT", code: "3911" },
  { name: "KAB. MESUJI", code: "3912" },
  { name: "KAB. PESISIR BARAT", code: "3913" },
  { name: "KOTA BANDAR LAMPUNG", code: "3991" },
  { name: "KOTA METRO", code: "3992" },
  { name: "KAB. BANJAR", code: "5101" },
  { name: "KAB. TANAH LAUT", code: "5102" },
  { name: "KAB. TAPIN", code: "5103" },
  { name: "KAB. HULU SUNGAI SELATAN", code: "5104" },
  { name: "KAB. HULU SUNGAI TENGAH", code: "5105" },
  { name: "KAB. HULU SUNGAI UTARA", code: "5106" },
  { name: "KAB. BARITO KUALA", code: "5107" },
  { name: "KAB. KOTA BARU", code: "5108" },
  { name: "KAB. TABALONG", code: "5109" },
  { name: "KAB.TANAH BUMBU", code: "5110" },
  { name: "KAB. BALANGAN", code: "5111" },
  { name: "KOTA BANJARMASIN", code: "5191" },
  { name: "KOTA BANJARBARU", code: "5192" },
  { name: "KAB. PONTIANAK", code: "5301" },
  { name: "KAB. SAMBAS", code: "5302" },
  { name: "KAB. KETAPANG", code: "5303" },
  { name: "KAB. SANGGAU", code: "5304" },
  { name: "KAB. SINTANG", code: "5305" },
  { name: "KAB. KAPUAS HULU", code: "5306" },
  { name: "KAB. BENGKAYANG", code: "5307" },
  { name: "KAB. LANDAK", code: "5308" },
  { name: "KAB. SEKADAU", code: "5309" },
  { name: "KAB. MELAWI", code: "5310" },
  { name: "KAB. KAYONG UTARA", code: "5311" },
  { name: "KAB. KUBU RAYA", code: "5312" },
  { name: "KOTA PONTIANAK", code: "5391" },
  { name: "KOTA SINGKAWANG", code: "5392" },
  { name: "KAB. KUTAI KARTANEGARA", code: "5401" },
  { name: "KAB. BERAU", code: "5402" },
  { name: "KAB. PASIR", code: "5403" },
  { name: "KAB. BULUNGAN", code: "5404" },
  { name: "KAB. KUTAI BARAT", code: "5405" },
  { name: "KAB. KUTAI TIMUR", code: "5406" },
  { name: "KAB. NUNUKAN", code: "5409" },
  { name: "KAB. MALINAU", code: "5410" },
  { name: "KAB. PENAJAM PASER UTARA", code: "5411" },
  { name: "KAB. TANA TIDUNG", code: "5412" },
  { name: "KAB. MAHAKAM ULU", code: "5413" },
  { name: "KOTA SAMARINDA", code: "5491" },
  { name: "KOTA BALIKPAPAN", code: "5492" },
  { name: "KOTA TARAKAN", code: "5493" },
  { name: "KOTA BONTANG", code: "5494" },
  { name: "KAB. KAPUAS", code: "5801" },
  { name: "KAB. KOTAWARINGIN BARAT", code: "5802" },
  { name: "KAB. KOTAWARINGIN TIMUR", code: "5803" },
  { name: "KAB. MURUNG RAYA", code: "5804" },
  { name: "KAB. BARITO TIMUR", code: "5805" },
  { name: "KAB. BARITO SELATAN", code: "5806" },
  { name: "KAB. GUNUNG MAS", code: "5807" },
  { name: "KAB. BARITO UTARA", code: "5808" },
  { name: "KAB. PULANG PISAU", code: "5809" },
  { name: "KAB. SERUYAN", code: "5810" },
  { name: "KAB. KATINGAN", code: "5811" },
  { name: "KAB. SUKAMARA", code: "5812" },
  { name: "KAB. LAMANDAU", code: "5813" },
  { name: "KOTA PALANGKARAYA", code: "5892" },
  { name: "KAB. DONGGALA", code: "6001" },
  { name: "KAB. POSO", code: "6002" },
  { name: "KAB. PARIMO/BANGGAI", code: "6003" },
  { name: "KAB. TOLI-TOLI", code: "6004" },
  { name: "KAB.BANGGAI KEPULAUAN", code: "6005" },
  { name: "KAB. MOROWALI", code: "6006" },
  { name: "KAB. BUOL", code: "6007" },
  { name: "KAB. TOJO UNA-UNA", code: "6008" },
  { name: "KAB. PARIGI MOUTONG", code: "6009" },
  { name: "KAB. SIGI", code: "6010" },
  { name: "KAB. BANGGAI LAUT", code: "6011" },
  { name: "KAB. MOROWALI UTARA", code: "6012" },
  { name: "KOTA PALU", code: "6091" },
  { name: "KAB. PINRANG", code: "6101" },
  { name: "KAB. GOWA", code: "6102" },
  { name: "KAB. WAJO", code: "6103" },
  { name: "KAB. BONE", code: "6105" },
  { name: "KAB. TANA TORAJA", code: "6106" },
  { name: "KAB. MAROS", code: "6107" },
  { name: "KAB. LUWU", code: "6109" },
  { name: "KAB. SINJAI", code: "6110" },
  { name: "KAB. BULUKUMBA", code: "6111" },
  { name: "KAB. BANTAENG", code: "6112" },
  { name: "KAB. JENEPONTO", code: "6113" },
  { name: "KAB. SELAYAR", code: "6114" },
  { name: "KAB. TAKALAR", code: "6115" },
  { name: "KAB. BARRU", code: "6116" },
  { name: "KAB. SIDENRENG RAPPANG", code: "6117" },
  { name: "KAB. PANGKAJENE KEPULAUAN", code: "6118" },
  { name: "KAB. SOPPENG (D/H WATANSOPPENG)", code: "6119" },
  { name: "KAB. ENREKANG", code: "6121" },
  { name: "KAB. LUWU TIMUR (D/H LUWU SELATAN)", code: "6122" },
  { name: "KAB. LUWU UTARA", code: "6124" },
  { name: "KAB. TORAJA UTARA", code: "6125" },
  { name: "KOTA MAKASSAR", code: "6191" },
  { name: "KOTA PARE-PARE", code: "6192" },
  { name: "KOTA PALOPO", code: "6193" },
  { name: "KAB. MINAHASA", code: "6202" },
  { name: "KAB. BOLAANG MONGONDOW", code: "6203" },
  { name: "KAB. KEPULAUAN SANGIHE", code: "6204" },
  { name: "KAB. KEPULAUAN TALAUD", code: "6205" },
  { name: "KAB. MINAHASA SELATAN", code: "6206" },
  { name: "KAB. MINAHASA UTARA", code: "6207" },
  { name: "KAB. MINAHASA TENGGARA", code: "6209" },
  { name: "KAB. BOLAANG MONGONDOW UTARA", code: "6210" },
  { name: "KAB. KEPULAUAN SITARO", code: "6211" },
  { name: "KAB. BOLAANG MONGONDOW SELATAN", code: "6212" },
  { name: "KAB. BOLAANG MONGONDOW TIMUR", code: "6213" },
  { name: "KOTA MENADO", code: "6291" },
  { name: "KOTA KOTAMOBAGU", code: "6292" },
  { name: "KOTA BITUNG", code: "6293" },
  { name: "KOTA. TOMOHON", code: "6294" },
  { name: "KAB. GORONTALO", code: "6301" },
  { name: "KAB. BUALEMO", code: "6302" },
  { name: "KAB. BONEBOLANGO", code: "6303" },
  { name: "KAB. POHUWATO", code: "6304" },
  { name: "KAB. GORONTALO UTARA", code: "6305" },
  { name: "KOTA GORONTALO", code: "6391" },
  { name: "KAB. POLEWALI MANDAR", code: "6401" },
  { name: "KAB. MAJENE", code: "6402" },
  { name: "KAB. MAMASA", code: "6403" },
  { name: "KAB. MAMUJU UTARA", code: "6404" },
  { name: "KAB. MAMUJU TENGAH", code: "6405" },
  { name: "KAB. MAMUJU (LBU 2016)", code: "6406" },
  { name: "KOTA MAMUJU", code: "6491" },
  { name: "KAB. BUTON", code: "6901" },
  { name: "KAB. MUNA", code: "6903" },
  { name: "KAB. KOLAKA", code: "6904" },
  { name: "KAB. WAKATOBI", code: "6905" },
  { name: "KAB. KONAWE", code: "6906" },
  { name: "KAB. KONAWE SELATAN", code: "6907" },
  { name: "KAB. BOMBANA", code: "6908" },
  { name: "KAB. KOLAKA UTARA", code: "6909" },
  { name: "KAB. BUTON UTARA", code: "6910" },
  { name: "KAB. KONAWE UTARA", code: "6911" },
  { name: "KAB. KALOKA TIMUR", code: "6912" },
  { name: "KAB. KONAWE KEPULAUAN", code: "6913" },
  { name: "KAB. BUTON SELATAN", code: "6914" },
  { name: "KAB. BUTON TENGAH", code: "6915" },
  { name: "KAB. MUNA BARAT", code: "6916" },
  { name: "KOTA BAU-BAU", code: "6990" },
  { name: "KOTA KENDARI", code: "6991" },
  { name: "KAB. LOMBOK BARAT", code: "7101" },
  { name: "KAB. LOMBOK TENGAH", code: "7102" },
  { name: "KAB. LOMBOK TIMUR", code: "7103" },
  { name: "KAB. SUMBAWA", code: "7104" },
  { name: "KAB. BIMA", code: "7105" },
  { name: "KAB. DOMPU", code: "7106" },
  { name: "KAB. SUMBAWA BARAT", code: "7107" },
  { name: "KAB. LOMBOK UTARA", code: "7108" },
  { name: "KOTA MATARAM", code: "7191" },
  { name: "KOTA. BIMA", code: "7192" },
  { name: "KAB. BULELENG", code: "7201" },
  { name: "KAB. JEMBRANA", code: "7202" },
  { name: "KAB. TABANAN", code: "7203" },
  { name: "KAB. BADUNG", code: "7204" },
  { name: "KAB. GIANYAR", code: "7205" },
  { name: "KAB. KLUNGKUNG", code: "7206" },
  { name: "KAB. BANGLI", code: "7207" },
  { name: "KAB. KARANGASEM", code: "7208" },
  { name: "KOTA DENPASAR", code: "7291" },
  { name: "KAB. KUPANG", code: "7401" },
  { name: "KAB. TIMOR-TENGAH SELATAN", code: "7402" },
  { name: "KAB. TIMOR-TENGAH UTARA", code: "7403" },
  { name: "KAB. BELU", code: "7404" },
  { name: "KAB. ALOR", code: "7405" },
  { name: "KAB. FLORES TIMUR", code: "7406" },
  { name: "KAB. SIKKA", code: "7407" },
  { name: "KAB. ENDE", code: "7408" },
  { name: "KAB. NGADA", code: "7409" },
  { name: "KAB. MANGGARAI", code: "7410" },
  { name: "KAB. SUMBA TIMUR", code: "7411" },
  { name: "KAB. SUMBA BARAT", code: "7412" },
  { name: "KAB. LEMBATA", code: "7413" },
  { name: "KAB. ROTE", code: "7414" },
  { name: "KAB. MANGGARAI BARAT", code: "7415" },
  { name: "KAB. SUMBA TENGAH", code: "7416" },
  { name: "KAB. SUMBA BARAT DAYA", code: "7417" },
  { name: "KAB. MANGGARAI TIMUR", code: "7418" },
  { name: "KAB. NAGEKEO", code: "7419" },
  { name: "KAB. SABU RAIJUA", code: "7420" },
  { name: "KAB. MALAKA", code: "7421" },
  { name: "KOTA KUPANG", code: "7491" },
  { name: "KAB. MALUKU TENGAH", code: "8101" },
  { name: "KAB. MALUKU TENGGARA", code: "8102" },
  { name: "KAB. MALUKU TENGGARA BARAT", code: "8103" },
  { name: "KAB. BURU", code: "8104" },
  { name: "KABUPATEN SERAM BAGIAN BARAT", code: "8105" },
  { name: "KABUPATEN SERAM BAGIAN TIMUR", code: "8106" },
  { name: "KABUPATEN KEPULAUAN ARU", code: "8107" },
  { name: "KAB. MALUKU BARAT DAYA", code: "8108" },
  { name: "KAB. BURU SELATAN", code: "8109" },
  { name: "KOTA AMBON", code: "8191" },
  { name: "KOTA TUAL", code: "8192" },
  { name: "KAB. JAYAPURA", code: "8201" },
  { name: "KAB. BIAK NUMFOR", code: "8202" },
  { name: "KAB. YAPEN-WAROPEN", code: "8210" },
  { name: "KAB. MERAUKE", code: "8211" },
  { name: "KAB. PANIAI", code: "8212" },
  { name: "KAB. JAYAWIJAYA", code: "8213" },
  { name: "KAB. NABIRE", code: "8214" },
  { name: "KAB. MIMIKA", code: "8215" },
  { name: "KAB. PUNCAK JAYA", code: "8216" },
  { name: "KAB. SARMI", code: "8217" },
  { name: "KAB. KEEROM", code: "8218" },
  { name: "KAB. PEGUNUNGAN BINTANG", code: "8221" },
  { name: "KAB. YAHUKIMO", code: "8222" },
  { name: "KAB. TOLIKARA", code: "8223" },
  { name: "KAB. WAROPEN", code: "8224" },
  { name: "KAB. BOVEN DIGOEL", code: "8226" },
  { name: "KAB. MAPPI", code: "8227" },
  { name: "KAB. ASMAT", code: "8228" },
  { name: "KAB. SUPIORI", code: "8231" },
  { name: "KAB. MAMBERAMO RAYA", code: "8232" },
  { name: "KAB. DOGIYAI", code: "8233" },
  { name: "KAB. LANNY JAYA", code: "8234" },
  { name: "KAB. MAMBERAMO TENGAH", code: "8235" },
  { name: "KAB. NDUGA TENGAH", code: "8236" },
  { name: "KAB. YALIMO", code: "8237" },
  { name: "KAB. PUNCAK", code: "8238" },
  { name: "KAB. INTAN JAYA", code: "8239" },
  { name: "KAB. DEIYAI", code: "8240" },
  { name: "KOTA JAYAPURA", code: "8291" },
  { name: "KAB. HALMAHERA TENGAH", code: "8302" },
  { name: "KAB. HALMAHERA UTARA", code: "8303" },
  { name: "KAB. HALMAHERA TIMUR", code: "8304" },
  { name: "KAB. HALMAHERA BARAT", code: "8305" },
  { name: "KAB. HALMAHERA SELATAN", code: "8306" },
  { name: "KAB. KEPULAUAN SULA", code: "8307" },
  { name: "KAB. PULAU MOROTAI", code: "8308" },
  { name: "KAB. PULAU TALIABU", code: "8309" },
  { name: "KOTA TERNATE", code: "8390" },
  { name: "KOTA TIDORE KEPULAUAN", code: "8391" },
  { name: "KAB. SORONG", code: "8401" },
  { name: "KAB. FAK-FAK", code: "8402" },
  { name: "KAB. MANOKWARI", code: "8403" },
  { name: "KAB. SORONG SELATAN", code: "8404" },
  { name: "KAB. RAJA AMPAT", code: "8405" },
  { name: "KAB. KAIMANA", code: "8406" },
  { name: "KAB. TELUK BINTUNI", code: "8407" },
  { name: "KAB. TELUK WONDAMA", code: "8408" },
  { name: "KAB. TEMBRAUW", code: "8409" },
  { name: "KAB. MAYBRAT", code: "8410" },
  { name: "KAB. PEGUNUNGAN ARFAK", code: "8411" },
  { name: "KAB. MANOKWARI SELATAN", code: "8412" },
  { name: "KOTA SORONG", code: "8491" },
  { name: "DI LUAR INDONESIA", code: "9999" },
];

export const OCCUPATIONS = [
  { name: "Accounting/Finance Officer", code: "001" },
  { name: "Customer service", code: "002" },
  { name: "Engineering", code: "003" },
  { name: "Eksekutif", code: "004" },
  { name: "Administrasi umum", code: "005" },
  { name: "Teknologi Informasi", code: "006" },
  { name: "Konsultan/Analis", code: "007" },
  { name: "Marketing", code: "008" },
  { name: "Pengajar (Guru, Dosen)", code: "009" },
  { name: "Militer", code: "010" },
  { name: "Pensiunan", code: "011" },
  { name: "Pelajar/Mahasiswa", code: "012" },
  { name: "Wiraswasta", code: "013" },
  { name: "Polisi", code: "014" },
  { name: "Petani", code: "015" },
  { name: "Nelayan", code: "016" },
  { name: "Peternak", code: "017" },
  { name: "Dokter", code: "018" },
  { name: "Tenaga Medis (Perawat, Bidan, dsb)", code: "019" },
  { name: "Hukum (Pengacara, Notaris)", code: "020" },
  { name: "Perhotelan & Restoran (Koki, Bartender, dsb)", code: "021" },
  { name: "Peneliti", code: "022" },
  { name: "Desainer", code: "023" },
  { name: "Arsitek", code: "024" },
  { name: "Pekerja Seni (Artis, Musisi, Pelukis, dsb)", code: "025" },
  { name: "Pengamanan", code: "026" },
  { name: "Pialang/Broker", code: "027" },
  { name: "Distributor", code: "028" },
  { name: "Transportasi Udara (Pilot, Pramugari)", code: "029" },
  { name: "Transportasi Laut (Nahkoda, ABK)", code: "030" },
  { name: "Transportasi Darat (Masinis, Sopir, Kondektur)", code: "031" },
  { name: "Buruh (Buruh Pabrik, Buruh Bangunan, Buruh Tani)", code: "032" },
  {
    name: "Pertukangan & Pengrajin (Tukang Kayu, Pengrajin Kulit, dll)",
    code: "033",
  },
  { name: "Ibu Rumah Tangga", code: "034" },
  {
    name: "Pekerja Informal (Asisten Rumah Tangga, Asongan, dll)",
    code: "035",
  },
  { name: "Pejabat Negara/Penyelenggara Negara", code: "036" },
  {
    name: "Pegawai Pemerintahan/Lembaga Negara (selain Pejabat/Penyelenggara Negara)",
    code: "037",
  },
  { name: "Lain-lain", code: "099" },
];

export const EDUCATION_DEGREES = [
  { name: "Tanpa Gelar", code: "0" },
  { name: "D1", code: "1" },
  { name: "D2", code: "2" },
  { name: "D3", code: "3" },
  { name: "S1", code: "4" },
  { name: "S2", code: "5" },
  { name: "S3", code: "6" },
  { name: "Lainnya", code: "99" },
] as const;

export const TARGET_MARKETS = [
  { name: "Karyawan", code: "01" },
  { name: "Pensiunan", code: "02" },
  { name: "Profesion", code: "03" },
  { name: "Wiraswasta", code: "04" },
] as const;
